import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';

import Fa from 'react-fontawesome';
import { reduce } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import GodTable, { CUSTOM_FIELD_TYPES } from '../../../../components/god-table';
import SaleRepsNameRenderer from '../../../../components/table-cells/SaleRepsNameRenderer';
// import ForecastForm from '../forecast-form';
import { getTablePreference, getHeaderHeight } from '../../../App/AppReducer';
import NumberRenderer from '../../../../components/table-cells/NumberRenderer';
import MoneyRenderer from '../../../../components/table-cells/MoneyRenderer';
import TenureRenderer from '../../../../components/table-cells/TenureRenderer';
import BarChartRenderer from '../../../../components/table-cells/BarChartRenderer';
import { getHasNoDecisionSetup, getForecastCategoryFilter } from '../../../../components/search-form/search-form-reducer';

import styles from './styles.css';

const USER_PREFERENCE_STATUS = 'performance-table-status';
const USER_PREFERENCE_REPORT_TYPE = 'performance-table-report-type';

const TABLE_NAME = 'performance-table';
const STATUS_COLUMN_ID = '__STATUS__';

class OpportunityTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null, // null, active, inactive
      tableType: 'amount',
      fullScreenMode: props.fullScreenMode,
      navHeight: 0,
    };
    this.setStatus = this.setStatus.bind(this);
    this.setTableType = this.setTableType.bind(this);
    this.onExitFullScreen = this.onExitFullScreen.bind(this);
    this.onEnterFullScreen = this.onEnterFullScreen.bind(this);
    this.onResizeTabs = this.onResizeTabs.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
  }

  componentWillMount() {
    const { rememberControlStates } = this.props;
    if (rememberControlStates) {
      const { userPreferences } = this.context;
      const status = userPreferences[USER_PREFERENCE_STATUS] || null;
      const tableType = userPreferences[USER_PREFERENCE_REPORT_TYPE] || 'amount';
      this.setState({
        tableType, status,
      });
    }
  }

  onExitFullScreen() {
    this.setState({ fullScreenMode: false });
    this.props.onExitFullScreen();
  }

  onEnterFullScreen() {
    this.setState({ fullScreenMode: true });
  }

  onResizeTabs(width, navHeight) {
    this.setState({ navHeight: navHeight + 10 });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.updateTableFilters();
  }

  setStatus(status) {
    this.setState({ status }, () => {
      this.updateTableFilters();
    });
    this.updateUserPreference(USER_PREFERENCE_STATUS, status);
  }


  setTableType(tableType) {
    this.setState({ tableType });
    this.updateUserPreference(USER_PREFERENCE_REPORT_TYPE, tableType);
  }

  getSalesRepColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'owner.name',
      enableRowGroup: true,
      enablePivot: true,
      cellRenderer: 'saleRepsNameRenderer',
      keyCreator: (params) => {
        const vals = params.value;
        if (!vals || (vals && vals.length === 0)) {
          return '--';
        }
        return vals;
      },
      cellRendererParams: {
        column,
        displayStatus: true,
      },
    };
  }

  getTenuresColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'owner.tenures',
      cellRenderer: 'tenureRenderer',
      type: 'numericColumn',
      cellClass: 'text-left',
      cellRendererParams: {
        column: {
          ...column,
          description: 'Length of sales tenure',
        },
      },
    };
  }

  getAccuracyColumn(column) {
    const {
      forecastClosedMonths, forecastCategoryFilter, forecastPeriod,
    } = this.props;
    let periodLabel = forecastPeriod;
    if (periodLabel === 'week') {
      periodLabel = 'weekly';
    } else if (periodLabel === 'month') {
      periodLabel = 'monthly';
    } else if (periodLabel === '60-day') {
      periodLabel = '60-day';
    } else if (periodLabel === '90-day') {
      periodLabel = '90-day';
    }
    if (forecastClosedMonths > 0 && forecastCategoryFilter && forecastCategoryFilter.mappings.length > 0) {
      return {
        colId: column._id,
        headerName: column.label,
        width: column.width,
        hide: !column.is_visible,
        type: 'numericColumn',
        cellClass: (params) => {
          const forecast = params.value;
          let cls = null;
          if (forecast === null) {
            cls = 'text-muted';
          } else if (forecast >= 0 && forecast <= 50) {
            cls = 'text-danger';
          } else if (forecast > 50 && forecast < 80) {
            cls = 'text-warning';
          } else if (forecast >= 80) {
            cls = 'text-success';
          }
          return cls;
        },
        valueGetter: (params) => {
          const { forecastKey } = this.props;
          if (params.node.group) {
            // groupping
            return null;
          }
          const { data } = params;
          const statusKey = `$${forecastKey}Status`;
          const dataKey = `${forecastKey}Forecast`;
          const hasForecast = data[statusKey] === 'loaded' && data[dataKey] !== null && data[dataKey] !== undefined;
          if (!hasForecast || data[statusKey] === 'loading') {
            return null;
          }
          const forecast = data[`${forecastKey}Forecast`];
          const value = Math.min(forecast, 1);
          return value * 100;
        },
        cellRendererParams: {
          column: {
            ...column,
            description: `The average ${periodLabel} forecast accuracy for the sales rep`,
          },
          suffix: '%',
          precision: 1,
        },
        valueFormatter: (params) => {
          if (!params) {
            return null;
          }
          if (params.value === null) {
            return 'N/A';
          }
          return params.value;
        },
        cellRendererSelector: (params) => {
          if (!params) {
            return null;
          }
          if (params.value === null) {
            return {
              component: null,
            };
          }
          return {
            component: 'barChartRenderer',
            params: {},
          };
        },

      };
    }
    return null;
  }

  getAvgDealSizeColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'avgDealSize',
      cellRenderer: 'moneyRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
      },
    };
  }

  getAvgPursuitTimeColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'avgPursuitTime',
      cellRenderer: 'numberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        suffix: 'days',
        suffixIsUnit: true,
      },
    };
  }

  getAvgDaysPushedColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'avgDaysPushed',
      cellRenderer: 'numberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        suffix: 'days',
        suffixIsUnit: true,
      },
    };
  }

  getAvgPushFrequencyColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'avgPushFrequency',
      cellRenderer: 'numberRenderer',
      type: 'numericColumn',
      cellRendererParams: {
        column,
        suffix: 'time',
        precision: 2,
        suffixIsUnit: true,
      },
    };
  }


  getStageColumn(column, stage) {
    const { tableType } = this.state;
    let cellClass = null;
    if (stage === 'won') {
      cellClass = 'text-success';
    } else if (stage === 'lost') {
      cellClass = 'text-danger';
    } else if (stage === 'noDecision') {
      cellClass = 'text-warning';
    }
    return {
      colId: column._id,
      groupId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellRendererParams: {
        column,
      },
      type: 'numericColumn',
      marryChildren: true,
      headerClass: `${cellClass} text-center text-uppercase`,
      children: [
        {
          colId: `${column._id}-first`,
          headerName: tableType === 'count' ? 'Count' : 'Amount',
          field: tableType === 'count' ? `stages.${stage}.total` : `stages.${stage}.amount`,
          type: 'numericColumn',
          cellRenderer: tableType === 'count' ? 'numberRenderer' : 'moneyRenderer',
          cellRendererParams: {
            column: {},
          },
          width: 100,
          cellClass: `text-right ${cellClass}`,
          suppressMenu: true,
          headerClass: cellClass,
        },
        {
          colId: `${column._id}-second`,
          headerName: 'Percentage',
          field: tableType === 'count' ? `stages.${stage}.countPercentage` : `stages.${stage}.amountPercentage`,
          type: 'numericColumn',
          cellRenderer: 'numberRenderer',
          cellRendererParams: {
            column: {},
            suffix: '%',
            precision: 1,
          },
          resizable: false,
          width: 120,
          cellClass: `text-right ${cellClass}`,
          suppressMenu: true,
          headerClass: cellClass,
        },
        {
          colId: `${column._id}-third`,
          headerName: 'Avg Deal Size',
          field: `stages.${stage}.avgDealSize`,
          type: 'numericColumn',
          cellRenderer: 'moneyRenderer',
          cellRendererParams: {
            column: {
              description: 'Average deal size, excluding deals with zero amounts',
            },
          },
          resizable: false,
          width: 150,
          cellClass: `text-right ${cellClass}`,
          suppressMenu: true,
          headerClass: cellClass,
        },
        {
          colId: `${column._id}-fourth`,
          headerName: 'Avg Pursuit Time',
          field: `stages.${stage}.avgPursuitTime`,
          type: 'numericColumn',
          cellRenderer: 'numberRenderer',
          cellRendererParams: {
            column: {
              description: 'Average days deals were pursued, excluding zero day and zero amount deals',
            },
            suffix: 'days',
            suffixIsUnit: true,
          },
          resizable: false,
          width: 150,
          cellClass: `text-right ${cellClass}`,
          suppressMenu: true,
          headerClass: cellClass,
        },
        {
          colId: `${column._id}-fifth`,
          headerName: 'Avg Days Pushed',
          field: `stages.${stage}.avgDaysPushed`,
          type: 'numericColumn',
          cellRenderer: 'numberRenderer',
          cellRendererParams: {
            column: {
              description: 'Average days opportunity close dates were adjusted, excluding deals with zero amounts',
            },
            suffix: 'days',
            suffixIsUnit: true,
          },
          resizable: false,
          width: 150,
          cellClass: `text-right ${cellClass}`,
          suppressMenu: true,
          headerClass: cellClass,
        },
        {
          colId: `${column._id}-sixth`,
          headerName: 'Avg Push Frequency',
          field: `stages.${stage}.avgPushFrequency`,
          type: 'numericColumn',
          cellRenderer: 'numberRenderer',
          cellRendererParams: {
            column: {
              description: 'Average number of times an opportunity\'s close date was pushed forward, excluding deals with zero amounts',
            },
            suffix: 'time',
            precision: 2,
            suffixIsUnit: true,
          },
          resizable: false,
          width: 160,
          cellClass: `text-right ${cellClass}`,
          suppressMenu: true,
          headerClass: cellClass,
        },
      ],
    };
  }

  getTotalColumn(column) {
    const { tableType } = this.state;
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: tableType === 'count' ? 'total' : 'amount',
      type: 'numericColumn',
      cellRenderer: tableType === 'count' ? 'numberRenderer' : 'moneyRenderer',
      cellRendererParams: {
        column,
      },
    };
  }

  getStatusColumn(column) {
    return {
      colId: STATUS_COLUMN_ID,
      headerName: column.label,
      width: column.width,
      hide: true,
      field: 'owner.is_active',
      resizable: false,
      suppressMenu: true,
      suppressMovableColumns: true,
      suppressFiltersToolPanel: true,
      suppressColumnsToolPanel: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        textMatcher: ({ value, filterText }) => {
          if (!filterText) {
            return false;
          }
          const fV = (filterText === 'active');
          return value === fV || value === `${fV ? 'true' : 'false'}`;
        }
      },
      cellRendererParams: {
        column,
      },
    };
  }

  getColDefs() {
    const { tableColumns, hasNoDecisionSetup } = this.props;
    return reduce(tableColumns, (columns, tableColumn) => {
      let column = null;
      if (tableColumn.tag === 'status') {
        column = this.getStatusColumn(tableColumn);
      } else if (tableColumn.tag === 'salesRep') {
        column = this.getSalesRepColumn(tableColumn);
      } else if (tableColumn.tag === 'tenures') {
        column = this.getTenuresColumn(tableColumn);
      } else if (tableColumn.tag === 'accuracy') {
        column = this.getAccuracyColumn(tableColumn);
      } else if (tableColumn.tag === 'avgDealSize') {
        column = this.getAvgDealSizeColumn(tableColumn);
      } else if (tableColumn.tag === 'avgPursuitTime') {
        column = this.getAvgPursuitTimeColumn(tableColumn);
      } else if (tableColumn.tag === 'avgDaysPushed') {
        column = this.getAvgDaysPushedColumn(tableColumn);
      } else if (tableColumn.tag === 'avgPushFrequency') {
        column = this.getAvgPushFrequencyColumn(tableColumn);
      } else if (tableColumn.tag === 'won') {
        column = this.getStageColumn(tableColumn, 'won');
      } else if (tableColumn.tag === 'lost') {
        column = this.getStageColumn(tableColumn, 'lost');
      } else if (tableColumn.tag === 'noDecision') {
        if (hasNoDecisionSetup) {
          column = this.getStageColumn(tableColumn, 'noDecision');
        }
      } else if (tableColumn.tag === 'total') {
        column = this.getTotalColumn(tableColumn);
      } else {
        column = {
          column: tableColumn,
          customFieldType: CUSTOM_FIELD_TYPES.USER,
        };
      }
      if (column) {
        columns.push(column);
      }
      return columns;
    }, []);
  }

  updateUserPreference(key, value) {
    if (this.props.rememberControlStates) {
      this.context.updateUserPreference(key, value);
    }
  }

  updateTableFilters() {
    if (this.gridApi) {
      const columnFilter = this.gridApi.getFilterInstance(STATUS_COLUMN_ID);
      if (columnFilter) {
        const { status } = this.state;
        if (status) {
          columnFilter.setModel({
            filterType: 'text',
            type: 'equals',
            filter: status,
          });
        } else {
          columnFilter.setModel(null);
        }
        this.gridApi.onFilterChanged();
      }
    }
  }

  renderEmptyMessage() {
    return (
      <div className="alert alert-warning">
        <p><strong><Fa name="exclamation-triangle" /> No records found matching your criteria.</strong></p>
      </div>
    );
  }
  renderTable(opportunities) {
    const { enableFullScreen, fullScreenMode } = this.props;
    const { navHeight } = this.state;
    const columnDefs = this.getColDefs();
    return (
      <GodTable
        id={TABLE_NAME}
        columnDefs={columnDefs}
        rowData={opportunities}
        onGridReady={this.onGridReady}
        context={{ statUnit: 'Sales Reps' }}
        frameworkComponents={{
          saleRepsNameRenderer: SaleRepsNameRenderer,
          numberRenderer: NumberRenderer,
          moneyRenderer: MoneyRenderer,
          tenureRenderer: TenureRenderer,
          barChartRenderer: BarChartRenderer,
        }}
        enableFullScreen={enableFullScreen}
        fullScreenMode={fullScreenMode}
        onExitFullScreen={this.onExitFullScreen}
        onEnterFullScreen={this.onEnterFullScreen}
        fullScreenOffset={{ y: navHeight }}
        tableManageConfigs={{
          enableCustomMeta: true,
          validObjects: ['User'],
          validCustomMetaObjects: ['User'],
        }}
        resourceType={GodTable.RESOURCE_TYPE.USER}
      />
    );
  }

  render() {
    const {
      stats, displayTitle, siteHeaderHeight,
    } = this.props;
    const {
      tableType, status, fullScreenMode,
    } = this.state;

    const filteredOpportunities = stats;

    if (stats.length === 0) {
      return this.renderEmptyMessage();
    }

    const allStatus = [
      { value: null, label: 'All Reps' },
      { value: 'active', label: 'Active Reps' },
      { value: 'inactive', label: 'Inactive Reps' },
    ];
    const cls = ['sub-header-with-controls'];
    const stl = {};
    if (fullScreenMode) {
      cls.push(styles.fullScreenNav);
      cls.push('animated');
      cls.push('fadeIn');
      stl.top = siteHeaderHeight;
    }


    return (
      <div>
        <div>
          {displayTitle && <h4 className="page-sub-header">Sales Performance Details</h4>}
          <h5 className={`${cls.join(' ')}`} style={stl}>
            <ReactResizeDetector handleHeight onResize={this.onResizeTabs} />
            <Dropdown
              id="perf-status-dropdown"
            >
              <Dropdown.Toggle bsSize="small">
                {allStatus.map((s) => {
                  if (s.value !== status) {
                    return null;
                  }
                  return (
                    <span key={s.value}>{s !== null ? s.label : 'All Reps'}</span>
                  );
                })}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {allStatus.map(s => (
                  <MenuItem
                    key={s.value}
                    active={status === s.value}
                    onSelect={() => { this.setStatus(s.value); }}
                  >
                    {s !== null ? s.label : 'All Reps'}
                  </MenuItem>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            &nbsp;sales performanced by&nbsp;
            <Dropdown
              id="perf-detail-dropdown"
            >
              <Dropdown.Toggle bsSize="small">
                {tableType}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem
                  active={tableType === 'amount'}
                  onSelect={() => { this.setTableType('amount'); }}
                >
                  Amount
                </MenuItem>
                <MenuItem
                  active={tableType === 'count'}
                  onSelect={() => { this.setTableType('count'); }}
                >
                  Count
                </MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </h5>

        </div>
        {filteredOpportunities.length > 0 && this.renderTable(filteredOpportunities)}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    hasNoDecisionSetup: getHasNoDecisionSetup(state),
    forecastCategoryFilter: getForecastCategoryFilter(state),
    tableColumns: getTablePreference(state, TABLE_NAME),
    siteHeaderHeight: getHeaderHeight(state),
  };
}

OpportunityTable.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hasNoDecisionSetup: PropTypes.bool.isRequired,
  forecastClosedMonths: PropTypes.number.isRequired,
  forecastKey: PropTypes.string, // this is the attribute name to hold forecast data
  forecastPeriod: PropTypes.string,
  displayTitle: PropTypes.bool,
  forecastCategoryFilter: PropTypes.shape({
    mappings: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.string.isRequired,
    })),
  }),
  tableColumns: PropTypes.arrayOf(PropTypes.shape({})),
  rememberControlStates: PropTypes.bool,
  enableFullScreen: PropTypes.bool,
  fullScreenMode: PropTypes.bool,
  onExitFullScreen: PropTypes.func,
  siteHeaderHeight: PropTypes.number,
};

OpportunityTable.defaultProps = {
  forecastKey: 'table',
  forecastPeriod: 'month',
  displayTitle: true,
  forecastCategoryFilter: null,
  tableColumns: [],
  rememberControlStates: false,
  enableFullScreen: true,
  fullScreenMode: false,
  onExitFullScreen: () => {},
  siteHeaderHeight: 0,
};

OpportunityTable.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(OpportunityTable);
